export const translationKeys = {
  // Error Page
  ERROR_PAGE_TITLE: "error.title",
  ERROR_PAGE_DESCRIPTION: "error.description",
  ERROR_PAGE_FOOTER: "error.footer",
  ERROR_PAGE_ACTION: "error.action",
  // Dialog Post Mail
  DIALOG_POSTMAIL_TITLE: "dialog.postmail.title",
  DIALOG_POSTMAIL_BODY_1: "dialog.postmail.body.1",
  DIALOG_POSTMAIL_BODY_2: "dialog.postmail.body.2",
  DIALOG_POSTMAIL_SNACKBAR: "dialog.postmail.snackbar",
  DIALOG_POSTMAIL_ACTION: "dialog.postmail.action",

  // Documents Type
  DOCUMENT_TYPE_MONTHLY_STATEMENT_NAME: "document.type.monthly_statement.name",
  DOCUMENT_TYPE_INVESTOR_DOCUMENT_NAME: "document.type.investor_document.name",
  DOCUMENT_TYPE_TOKEN_DOCUMENT_NAME: "document.type.token_document.name",
  DOCUMENT_RELATED_BY_MULTIPLE: "document.related.by_multiple",

  // Document DataGrid Component
  DOCUMENT_DATAGRID_COLUMN_DATE_HEADER: "documents-datagrid.column.date.header",
  DOCUMENT_DATAGRID_COLUMN_TYPE_HEADER: "documents-datagrid.column.type.header",
  DOCUMENT_DATAGRID_COLUMN_RELATED_HEADER:
    "documents-datagrid.column.related.header",
  DOCUMENT_DATAGRID_PAGINATOR_LABEL_ROWS_PER_PAGE:
    "documents-datagrid.paginator.rows-per-page.label",
  DOCUMENT_DATAGRID_PAGINATOR_LABEL_DISPLAYED_ROWS:
    "documents-datagrid.paginator.displayed-rows.label",
  DOCUMENT_DATAGRID_PAGINATOR_LABEL_DISPLAYED_ROWS_MORE:
    "documents-datagrid.paginator.displayed-rows-more.label",
  DOCUMENT_DATAGRID_MENU_DOWNLOAD_LABEL:
    "documents-datagrid.menu.download.label",
  DOCUMENT_DATAGRID_MENU_POSTMAIL_LABEL:
    "documents-datagrid.menu.postmail.label",
  DOCUMENT_DATAGRID_DOWNLOAD_SNACKBAR_INFO:
    "documents-datagrid.download.snackbar.info",
  DOCUMENT_DATAGRID_DOWNLOAD_SNACKBAR_FAILED:
    "documents-datagrid.download.snackbar.failed",
  DOCUMENT_DATAGRID_EMPTY_TITLE: "documents-datagrid.empty.title",
  DOCUMENT_DATAGRID_EMPTY_DESCRIPTION: "documents-datagrid.empty.description",

  // Portfolio Statement / Download Asset Statement Modal
  PORTFOLIO_STATEMENT_BUTTON_LABEL: "portfolio-statement.button.label",
  PORTFOLIO_STATEMENT_MODAL_TITLE: "portfolio-statement.modal.title",
  PORTFOLIO_STATEMENT_SELECT_ALL: "portfolio-statement.select-all",
  PORTFOLIO_STATEMENT_DESELECT_ALL: "portfolio-statement.deselect-all",
  PORTFOLIO_STATEMENT_SELECTED_COUNT: "portfolio-statement.selected-count",
  PORTFOLIO_STATEMENT_GENERATE_BUTTON: "portfolio-statement.generate.button",
  PORTFOLIO_STATEMENT_ORDER_INFO: "portfolio-statement.order-info",
  PORTFOLIO_STATEMENT_DOWNLOAD_SUCCESS: "portfolio-statement.download.success",
  PORTFOLIO_STATEMENT_DOWNLOAD_ERROR: "portfolio-statement.download.error",
  PORTFOLIO_STATEMENT_LOADING_ASSETS: "portfolio-statement.loading-assets",
  PORTFOLIO_STATEMENT_NO_ASSETS: "portfolio-statement.no-assets",
  PORTFOLIO_STATEMENT_ASSETS_ERROR: "portfolio-statement.assets.error",

  // Date Range Section
  PORTFOLIO_STATEMENT_DATE_RANGE_TITLE: "portfolio-statement.date-range.title",
  PORTFOLIO_STATEMENT_DATE_RANGE_SUBTITLE:
    "portfolio-statement.date-range.subtitle",
  PORTFOLIO_STATEMENT_STARTING_DATE: "portfolio-statement.starting-date",
  PORTFOLIO_STATEMENT_ENDING_DATE: "portfolio-statement.ending-date",

  // Included Sections
  PORTFOLIO_STATEMENT_INCLUDED_SECTIONS_TITLE:
    "portfolio-statement.included-sections.title",
  PORTFOLIO_STATEMENT_INCLUDED_SECTIONS_SUBTITLE:
    "portfolio-statement.included-sections.subtitle",
  PORTFOLIO_STATEMENT_SECTION_INVESTMENT_OVERVIEW:
    "portfolio-statement.section.investment-overview",
  PORTFOLIO_STATEMENT_SECTION_PERFORMANCE_OVERVIEW:
    "portfolio-statement.section.performance-overview",
  PORTFOLIO_STATEMENT_SECTION_CUSTODY_OVERVIEW:
    "portfolio-statement.section.custody-overview",
  PORTFOLIO_STATEMENT_SECTION_TRANSACTION_HISTORY:
    "portfolio-statement.section.transaction-history",
  PORTFOLIO_STATEMENT_SECTION_PAYOUT_HISTORY:
    "portfolio-statement.section.payout-history",

  // Included Tokens
  PORTFOLIO_STATEMENT_INCLUDED_TOKENS_TITLE:
    "portfolio-statement.included-tokens.title",
  PORTFOLIO_STATEMENT_INCLUDED_TOKENS_SUBTITLE:
    "portfolio-statement.included-tokens.subtitle",

  // Download PDF Button
  PORTFOLIO_STATEMENT_DOWNLOAD_PDF: "portfolio-statement.download-pdf",

  // Error handling
  PORTFOLIO_STATEMENT_TRY_AGAIN: "portfolio-statement.try-again",
  PORTFOLIO_STATEMENT_NO_STATEMENTS:
    "portfolio-statement.no-statements-available",
  PORTFOLIO_STATEMENT_RATE_LIMITED: "portfolio-statement.rate-limited",
  PORTFOLIO_STATEMENT_GENERATING: "portfolio-statement.generating",
  PORTFOLIO_STATEMENT_TIMEOUT: "portfolio-statement.timeout",
  PORTFOLIO_STATEMENT_UNAUTHORIZED: "portfolio-statement.unauthorized",
  PORTFOLIO_STATEMENT_FORBIDDEN: "portfolio-statement.forbidden",
  PORTFOLIO_STATEMENT_INVALID_REQUEST: "portfolio-statement.invalid-request",
  PORTFOLIO_STATEMENT_SERVER_ERROR: "portfolio-statement.server-error",

  // Transactions Pending Actions Alert
  TRANSACTIONS_PENDING_ACTIONS_ALERT_TITLE:
    "transactions-pending-actions-alert.title",
  TRANSACTIONS_PENDING_ACTIONS_ALERT_SUBTITLE:
    "transactions-pending-actions-alert.subtitle",
  TRANSACTIONS_PENDING_ACTIONS_ALERT_CTA:
    "transactions-pending-actions-alert.cta",

  // Claim Redemption Modal
  CLAIM_REDEMPTION_MODAL_TITLE: "claim-redemption-modal.title",
  CLAIM_REDEMPTION_MODAL_DESCRIPTION: "claim-redemption-modal.description",
  CLAIM_REDEMPTION_MODAL_CONNECTED_WALLET_LABEL:
    "claim-redemption-modal.connected-wallet-label",
  CLAIM_REDEMPTION_MODAL_CLAIMABLE_WALLET_LABEL:
    "claim-redemption-modal.claimable-wallet-label",
  CLAIM_REDEMPTION_MODAL_SHARES_REDEEMED_LABEL:
    "claim-redemption-modal.shares-redeemed-label",
  CLAIM_REDEMPTION_MODAL_UNITS_NOT_REDEEMED_LABEL:
    "claim-redemption-modal.units-not-redeemed-label",
  CLAIM_REDEMPTION_MODAL_USDC_TO_CLAIM_LABEL:
    "claim-redemption-modal.usdc-to-claim-label",
  CLAIM_REDEMPTION_MODAL_SHARES_UNIT: "claim-redemption-modal.shares-unit",
  CLAIM_REDEMPTION_MODAL_CONNECT_WALLET_BUTTON:
    "claim-redemption-modal.connect-wallet-button",
  CLAIM_REDEMPTION_MODAL_CANCEL_BUTTON: "claim-redemption-modal.cancel-button",
  CLAIM_REDEMPTION_MODAL_SIGN_TRANSACTION_BUTTON:
    "claim-redemption-modal.sign-transaction-button",
  CLAIM_REDEMPTION_MODAL_ERROR_SNACKBAR:
    "claim-redemption-modal.error-snackbar",
  CLAIM_REDEMPTION_MODAL_SUCCESS_SNACKBAR:
    "claim-redemption-modal.success-snackbar",
  CLAIM_REDEMPTION_MODAL_WALLET_COPIED: "claim-redemption-modal.wallet-copied",
  CLAIM_REDEMPTION_MODAL_WRONG_WALLET_TITLE:
    "claim-redemption-modal.wrong-wallet-title",
  CLAIM_REDEMPTION_MODAL_WRONG_WALLET_DESCRIPTION:
    "claim-redemption-modal.wrong-wallet-description",
  CLAIM_REDEMPTION_MODAL_PRORATA_CALLOUT_TITLE:
    "claim-redemption-modal.prorata-callout-title",
  CLAIM_REDEMPTION_MODAL_PRORATA_CALLOUT_DESCRIPTION:
    "claim-redemption-modal.prorata-callout-description",

  // Tax Form Expiring Modal
  TAX_FORM_EXPIRING_MODAL_TITLE: "tax-form-expiring-modal.title",
  TAX_FORM_EXPIRING_MODAL_MESSAGE: "tax-form-expiring-modal.message",
  TAX_FORM_EXPIRING_MODAL_RENEW_BUTTON: "tax-form-expiring-modal.renew-button",
  TAX_FORM_EXPIRING_MODAL_REMIND_LATER_BUTTON:
    "tax-form-expiring-modal.remind-later-button",

  // Tax Form Expired Modal
  TAX_FORM_EXPIRED_MODAL_TITLE: "tax-form-expired-modal.title",
  TAX_FORM_EXPIRED_MODAL_MESSAGE: "tax-form-expired-modal.message",
  TAX_FORM_EXPIRED_MODAL_RENEW_BUTTON: "tax-form-expired-modal.renew-button",
  TAX_FORM_EXPIRED_MODAL_REMIND_LATER_BUTTON:
    "tax-form-expired-modal.remind-later-button",

  // Tax Form Invalid Modal
  TAX_FORM_INVALID_MODAL_TITLE: "tax-form-invalid-modal.title",
  TAX_FORM_INVALID_MODAL_MESSAGE_W9: "tax-form-invalid-modal.message-w9",
  TAX_FORM_INVALID_MODAL_MESSAGE_W8: "tax-form-invalid-modal.message-w8",
  TAX_FORM_INVALID_MODAL_REASON_TITLE: "tax-form-invalid-modal.reason-title",
  TAX_FORM_INVALID_MODAL_RENEW_BUTTON: "tax-form-invalid-modal.renew-button",
  TAX_FORM_INVALID_MODAL_REMIND_LATER_BUTTON:
    "tax-form-invalid-modal.remind-later-button",

  // Cancel Redemption Modal
  CANCEL_REDEMPTION_MODAL_TITLE: "cancel-redemption-modal.title",
  CANCEL_REDEMPTION_MODAL_DESCRIPTION: "cancel-redemption-modal.description",
  CANCEL_REDEMPTION_MODAL_CONNECTED_WALLET_LABEL:
    "cancel-redemption-modal.connected-wallet-label",
  CANCEL_REDEMPTION_MODAL_SIGNING_WALLET_LABEL:
    "cancel-redemption-modal.signing-wallet-label",
  CANCEL_REDEMPTION_MODAL_UNITS_RELEASED_LABEL:
    "cancel-redemption-modal.units-released-label",
  CANCEL_REDEMPTION_MODAL_ACKNOWLEDGEMENT:
    "cancel-redemption-modal.acknowledgement",
  CANCEL_REDEMPTION_MODAL_KEEP_BUTTON: "cancel-redemption-modal.keep-button",
  CANCEL_REDEMPTION_MODAL_CANCEL_BUTTON:
    "cancel-redemption-modal.cancel-button",
  CANCEL_REDEMPTION_MODAL_WALLET_COPIED:
    "cancel-redemption-modal.wallet-copied",
  CANCEL_REDEMPTION_MODAL_SUCCESS_SNACKBAR:
    "cancel-redemption-modal.success-snackbar",
  CANCEL_REDEMPTION_MODAL_WRONG_WALLET_DESCRIPTION:
    "cancel-redemption-modal.wrong-wallet-description",
  OPEN_ORDERS_WIDGET_TITLE: "open-orders-widget.title",
  OPEN_ORDERS_WIDGET_COLUMN_TYPE: "open-orders-widget.column-type",
  OPEN_ORDERS_WIDGET_COLUMN_STATUS: "open-orders-widget.column-status",
  OPEN_ORDERS_WIDGET_COLUMN_UNITS: "open-orders-widget.column-units",
  OPEN_ORDERS_WIDGET_COLUMN_PRICE: "open-orders-widget.column-price",
  OPEN_ORDERS_WIDGET_COLUMN_TOTAL_VALUE:
    "open-orders-widget.column-total-value",
  OPEN_ORDERS_WIDGET_COLUMN_WALLET: "open-orders-widget.column-wallet",
  OPEN_ORDERS_WIDGET_TYPE_SUBSCRIPTION: "open-orders-widget.type-subscription",
  OPEN_ORDERS_WIDGET_TYPE_REDEMPTION: "open-orders-widget.type-redemption",
  OPEN_ORDERS_WIDGET_STATUS_PROCESSING: "open-orders-widget.status-processing",
  OPEN_ORDERS_WIDGET_STATUS_USDC_AVAILABLE:
    "open-orders-widget.status-usdc-available",
  OPEN_ORDERS_WIDGET_STATUS_PROCESSING_TOOLTIP:
    "open-orders-widget.status-processing-tooltip",
  OPEN_ORDERS_WIDGET_STATUS_CANCELED: "open-orders-widget.status-canceled",
  OPEN_ORDERS_WIDGET_STATUS_CLAIMED: "open-orders-widget.status-claimed",
  OPEN_ORDERS_WIDGET_CANCEL_REDEMPTION: "open-orders-widget.cancel-redemption",
  OPEN_ORDERS_WIDGET_CLAIM_USDC: "open-orders-widget.claim-usdc",
  OPEN_ORDERS_WIDGET_EMPTY: "open-orders-widget.empty",
  // Transaction History
  TRANSACTION_HISTORY_TYPE_COLUMN: "Text.transaction-history.transaction-type-column-title",
  TRANSACTION_HISTORY_DATE_COLUMN: "Text.transaction-history.closed-timestamp-column-title",
  TRANSACTION_HISTORY_UNITS_COLUMN: "Text.transaction-history.units-column-title",
  TRANSACTION_HISTORY_PRICE_COLUMN: "Text.transaction-history.price-per-unit-column-title",
  TRANSACTION_HISTORY_AMOUNT_COLUMN: "Text.transaction-history.transaction-amount-column-title",
  TRANSACTION_HISTORY_FEE_COLUMN: "Text.transaction-history.fee-column-title",
  TRANSACTION_HISTORY_NETWORK_COLUMN: "Text.transaction-history.network-column-title",
  TRANSACTION_HISTORY_EMPTY_PRINCIPAL: "Text.transaction-history.empty-grid-principal-text",
  TRANSACTION_HISTORY_EMPTY_SECONDARY: "Text.transaction-history.empty-grid-secondary-text",
  TRANSACTION_HISTORY_ERROR_PRINCIPAL: "Text.transaction-history.error-grid-principal-text",
  TRANSACTION_HISTORY_ERROR_SECONDARY: "Text.transaction-history.error-grid-secondary-text",
  TRANSACTION_HISTORY_REFRESH: "Text.transaction-history.refresh-grid-text",
  TRANSACTION_HISTORY_MODAL_TITLE: "Text.transaction-history.modal-title",
  TRANSACTION_HISTORY_DETAIL_LINK: "Text.transaction-history.detail-link",
  TRANSACTION_HISTORY_DOWNLOAD_BUTTON: "Text.transaction-history.download_button_label",
  TRANSACTION_HISTORY_IN_PROGRESS: "Text.transaction-history.in-progress",
  TRANSACTION_HISTORY_COMPLETED: "Text.transaction-history.completed",
  TRANSACTION_HISTORY_CANCELLED: "Text.transaction-history.cancelled",
  TRANSACTION_TYPE_SELL: "Text.transaction-type.sell",
  TRANSACTION_TYPE_BUY: "Text.transaction-type.buy",
  TRANSACTION_TYPE_REDEMPTION: "Text.transaction-type.redemption",
  TRANSACTION_TYPE_ISSUANCE: "Text.transaction-type.issuance",
  TRANSACTION_TYPE_REALLOCATION: "Text.transaction-type.reallocation",
  TRANSACTION_TYPE_DESTROY: "Text.transaction-type.destroy",
  TRANSACTION_TYPE_LIQUIDITY: "Text.transaction-type.liquidity",
  DATAGRID_ROWS: "Text.datagrid.rows",
  DATAGRID_PAGE: "Text.datagrid.page",
  COST_BASIS_ADD_CTA: "Texts.cost-basis.add-cta",
  COST_BASIS_ALERT_TITLE: "Texts.cost-basis.alert-title",
  COST_BASIS_ALERT_BODY: "Texts.cost-basis.alert-body",
  COST_BASIS_ALERT_FILTER_BUTTON: "Texts.cost-basis.alert-filter-button",
  COST_BASIS_ALERT_FILTER_BUTTON_ACTIVE: "Texts.cost-basis.alert-filter-button-active",
  COST_BASIS_SUCCESS_TOAST: "Texts.cost-basis.success-toast",
  COST_BASIS_PENDING_VALUE: "Texts.cost-basis.pending-value",
  COST_BASIS_PENDING_VALUE_MESSAGE: "Texts.cost-basis.pending-value-message",
  COST_BASIS_ADD_COST_BASIS_CTA: "Texts.cost-basis.add-cost-basis-cta",
  COST_BASIS_CONFIRM_VALUE_CTA: "Texts.cost-basis.confirm-value-cta",
  COST_BASIS_INVALID_VALUE: "Texts.cost-basis.invalid-value",
  COST_BASIS_ERROR: "Texts.cost-basis.error",
  COST_BASIS_RETRY_BUTTON: "Texts.cost-basis.retry-button",
  PRICE_ALERT_MODAL_TITLE: "Text.price-alert.modal.title",
  PRICE_ALERT_MODAL_TEXT: "Text.price-alert.modal.text",
  PRICE_ALERT_MODAL_BUTTON: "Text.price-alert.modal.button",
  PRICE_ALERT_MODAL_COPIED: "Text.price-alert.modal.copied",

  // Payout History
  PAYOUT_HISTORY_DISTRIBUTION_TYPE_COLUMN: "Text.payout-history.distribution-type-column-title",
  PAYOUT_HISTORY_PAYOUT_DATE_COLUMN: "Text.payout-history.payout-date-column-title",
  PAYOUT_HISTORY_PAYOUT_METHOD_COLUMN: "Text.payout-history.payout-method-column-title",
  PAYOUT_HISTORY_WITHHOLDING_COLUMN: "Text.payout-history.withholding-column-title",
  PAYOUT_HISTORY_NET_AMOUNT_COLUMN: "Text.payout-history.net-amount-column-title",
  PAYOUT_HISTORY_NETWORK_COLUMN: "Text.payout-history.network-column-title",
  PAYOUT_HISTORY_EMPTY_PRINCIPAL: "Text.payout-history.empty-grid-principal-text",
  PAYOUT_HISTORY_EMPTY_SECONDARY: "Text.payout-history.empty-grid-secondary-text",
  PAYOUT_HISTORY_ERROR_PRINCIPAL: "Text.payout-history.error-grid-principal-text",
  PAYOUT_HISTORY_ERROR_SECONDARY: "Text.payout-history.error-grid-secondary-text",
  PAYOUT_HISTORY_REFRESH: "Text.payout-history.refresh-grid-text",
  PAYOUT_HISTORY_MODAL_TITLE: "Text.payout-history.modal-title",
  PAYOUT_HISTORY_DOWNLOAD_BUTTON: "Text.payout-history.download-button-label",
  PAYOUT_HISTORY_DOWNLOAD_MODAL_TITLE: "Text.payout-history.download-modal-title",
  PAYOUT_HISTORY_DOWNLOAD_MODAL_DESCRIPTION: "Text.payout-history.download-modal-description",
  PAYOUT_HISTORY_DOWNLOAD_MODAL_ACTION_1: "Text.payout-history.download-modal-action-1",
  PAYOUT_HISTORY_DOWNLOAD_MODAL_ACTION_GT1: "Text.payout-history.download-modal-action-gt1",
  PAYOUT_HISTORY_DOWNLOAD_MODAL_ACTION_DISABLED: "Text.payout-history.download-modal-action-disabled",
  DISTRIBUTION_TYPE_DIVIDEND: "Text.distribution-type.dividend",
  DISTRIBUTION_TYPE_REDEMPTION: "Text.distribution-type.redemption",
  DISTRIBUTION_TYPE_REDEMPTION_TBE: "Text.distribution-type.redemption-tbe",
  DISTRIBUTION_TYPE_INTEREST: "Text.distribution-type.interest",
  DISTRIBUTION_TYPE_BUY_BACK: "Text.distribution-type.buy-back",
  DISTRIBUTION_TYPE_RESCISSION: "Text.distribution-type.rescission",
  DISTRIBUTION_TYPE_OTHER: "Text.distribution-type.other",
  DISTRIBUTION_TYPE_ACCRUED_DIVIDEND: "Text.distribution-type.accrued-dividend",
  DISTRIBUTION_TYPE_REDEMPTION_EVERGREEN: "Text.distribution-type.redemption-evergreen",
  PAYOUT_METHOD_CRYPTO: "Text.payout-method.crypto",
  PAYOUT_METHOD_BANK_TRANSFER: "Text.payout-method.bank-transfer",
  PAYOUT_METHOD_TREASURY: "Text.payout-method.treasury",
  PAYOUT_METHOD_ESCROW: "Text.payout-method.escrow",
  PAYOUT_METHOD_CHECK: "Text.payout-method.check",
  PAYOUT_METHOD_DIGITAL_ASSET: "Text.payout-method.digital-asset",
  PAYOUT_METHOD_CASH_ACCOUNT: "Text.payout-method.cash-account",
  PAYOUT_METHOD_REINVEST: "Text.payout-method.reinvest",
  PAYOUT_METHOD_OTHER: "Text.payout-method.other",

  // Dividend Payout Method Modal
  DIVIDEND_PAYOUT_MODAL_TITLE: "Text.dividend-payout-modal.title",
  DIVIDEND_PAYOUT_MODAL_INFO: "Text.dividend-payout-modal.info",
  DIVIDEND_PAYOUT_MODAL_PAYOUT_METHOD_LABEL:
    "Text.dividend-payout-modal.payout-method-label",
  DIVIDEND_PAYOUT_MODAL_NETWORK_WALLET_TITLE:
    "Text.dividend-payout-modal.network-wallet-title",
  DIVIDEND_PAYOUT_MODAL_ADD_WALLET: "Text.dividend-payout-modal.add-wallet",
  DIVIDEND_PAYOUT_MODAL_EMPTY: "Text.dividend-payout-modal.empty",
  DIVIDEND_PAYOUT_MODAL_LOAD_ERROR: "Text.dividend-payout-modal.load-error",
  DIVIDEND_PAYOUT_MODAL_CANCEL: "Text.dividend-payout-modal.cancel",
  DIVIDEND_PAYOUT_MODAL_SAVE: "Text.dividend-payout-modal.save",
  DIVIDEND_PAYOUT_MODAL_SAVE_SUCCESS: "Text.dividend-payout-modal.save-success",
  DIVIDEND_PAYOUT_MODAL_SAVE_ERROR: "Text.dividend-payout-modal.save-error",

  // Dividend Payout Method Card
  DIVIDEND_PAYOUT_CARD_EDIT: "Text.dividend-payout-card.edit",
} as const;

export default translationKeys;

export type TranslationKey =
  (typeof translationKeys)[keyof typeof translationKeys];
